import { Params } from '@angular/router';

export interface ParsedUrl {
    href: string;
    protocol: string;
    host: string;
    hostname: string;
    port: string;
    path: string;
    search: string;
    hash: string;
}

export class UrlParser {
    private static readonly UrlParserRegex = new RegExp([
        '^(https?:)//', // protocol
        '(([^:/?#]*)(?::([0-9]+))?)', // host (hostname and port)
        '(/{0,1}[^?#]*)', // pathname
        '(\\?[^#]*|)', // search
        '(#.*|)$' // hash
    ].join(''));

    public static getHostName(url: string): string {
        const location = UrlParser.getLocation(url);
        return (location && location.hostname) || '';
    }

    public static getLocation(url: string): ParsedUrl {
        if (url && url.length) {
            const match = url.match(UrlParser.UrlParserRegex);
            return match && {
                href: url,
                protocol: match[1],
                host: match[2],
                hostname: match[3],
                port: match[4],
                path: match[5],
                search: match[6],
                hash: match[7]
            };
        }

        return null;
    }

    public static getQueryParams(search: string): Params {
        const queryParams: Params = {};
        if (search) {
            const queryStringEntries = search.split('&');
            for (const entry of queryStringEntries) {
                const [key, value] = entry.split('=');
                queryParams[key] = value;
            }
        }
        return queryParams;
    }

    public static getOrigin(url: string): string {
        const parsedUrl = UrlParser.getLocation(url);
        const origin = parsedUrl && parsedUrl.protocol && parsedUrl.hostname ? parsedUrl.protocol + '//' + parsedUrl.hostname : '';
        return origin;
    }

    public static removeFileNameFromDocUrl(url: string): string {
        if (!url) {
          return;
        }
        return url.substring(0, url.lastIndexOf('/'));
    }

    /**
     * Adds 'https://' to URLs not beginning with the following protocols: http, https, mailto, sip, tel and im.
     * @param {string} url - The URL.
     */
    public static addMissingProtocol(url: string): string {
        url = url.toLowerCase();
        // tslint:disable-next-line:no-http-string
        if (url && !url.startsWith('http:') && !url.startsWith('https:') && !url.startsWith('mailto:') &&
        !url.startsWith('sip:') && !url.startsWith('tel:') && !url.startsWith('im:')) {
            return 'https://' + url;
        }

        return url;
    }
}
